const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '24px'
  },
  cover: {
    display: 'block',
    minWidth: '70%',
    height: '200px',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundColor: '#e8e8e8',
    marginRight: '30px',
    borderRadius: '4px'
  },
  actions: {
    marginBottom: '10px'
  }
}

export default styles
